export const BASE_API_URL = import.meta.env.VITE_BASE_API_URL as string;
export const EXTERNAL_API_URL = import.meta.env.VITE_EXTERNAL_API_URL as string;
